import React from 'react';
import Plataforma_concursos from '../PlataformaConcursos/PlataformaConcursos';
import Footer from '../Footer';

const App: React.FC = () => {
  return (
    <div className="App">
      <Plataforma_concursos/>
      <Footer/>
    </div>
  );
};

export default App;